import dataLayerHelper from '../helpers/dataLayerHelper';
import setCookie from '../helpers/setCookie';

const $bar = $('.js-cookie-bar');

const SAVE_FOR_HOURS = 8760;

const cookieBar = {
  initialize() {
    if ($bar.length) {
      this.createEvents();
    }
  },

  createEvents() {
    $bar.on('click', '.js-cookie-bar-btn', () => {
      this.acceptedCookies();
    });
  },

  /**
   * The user accepted cookies, Yay!
   * @return {void}
   */
  acceptedCookies() {
    $bar.css({
      opacity: 0,
      transform: 'translateY(30px)',
    });

    setCookie('cookies_accepted', '1', SAVE_FOR_HOURS);

    dataLayerHelper.event('Cookie bar', 'closed');
  },
};

export default cookieBar;
